import { render, staticRenderFns } from "./BlipWaitingTicketsTable.vue?vue&type=template&id=b94ab798&scoped=true&"
import script from "./BlipWaitingTicketsTable.vue?vue&type=script&lang=js&"
export * from "./BlipWaitingTicketsTable.vue?vue&type=script&lang=js&"
import style0 from "./BlipWaitingTicketsTable.vue?vue&type=style&index=0&id=b94ab798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94ab798",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
installComponents(component, {VDataTable})
